







import Vue from 'vue';
import { BACKEND_URL } from '@/constants';
import qs from "qs";

const RECOVER_URL = BACKEND_URL + '/recover';

export default Vue.extend({

    data() {
        return {
            forgottenUser: '',
        };
    },

    methods: {
        recover(params: any) {
            Vue.axios.post(
                RECOVER_URL,
                qs.stringify({
                    forgotten_user: this.forgottenUser,
                }),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                }
            ).then((response: { data: any }) => {
                this.$store.dispatch('showUserFeedback', { message: response.data[1] });
                this.forgottenUser = '';
            });
        }
    }

});
